export function InfoCard({ title, content }) {
  return (
    <article className="p-3 mb-3 bg-white rounded-lg border border-solid border-stone-200 max-sm:mb-2">
      <h2 className="mb-3 text-lg font-bold text-zinc-800">{title}</h2>
      <p className="px-5 py-2.5 text-sm font-medium tracking-wide leading-snug bg-yellow-50 rounded-xl text-zinc-800">
        {content}
      </p>
    </article>
  );
}
